<ng-template #template>
  <!-- Amount Selection Screen -->
  <div *ngIf="showAmountSelection && !redeemDone">
    <div class="modal-header">
      <img src="assets/images/x-modal.svg" (click)="close()" alt="">
      <h5>{{ 'store.redeem.amountTitle' | translate }}</h5>
    </div>
    <div class="modal-body">
      <div class="amount-selection-subtitle">
        {{ 'store.redeem.amountSubtitle' | translate }}
      </div>

      <div class="label">{{ 'store.redeem.amountLabel' | translate }}</div>
      <div class="input-container">
        <div class="currency-input-wrapper">
          <span class="currency-prefix">{{currencyCode || 'ILS'}}</span>
          <input
            [(ngModel)]="redeemAmount"
            type="number"
            placeholder="0.00"
            min="1"
            max="1000"
            step="0.01"
            (input)="redeemAmount = $any($event.target).value">
        </div>
        <div class="amount-hint">{{ 'store.redeem.amountHint' | translate }}</div>
      </div>

      <div class="label">{{ 'store.redeem.quickSelect' | translate }}</div>
      <div class="quick-select-container">
        <button
          class="quick-select-btn"
          [class.active]="redeemAmount === 20"
          (click)="selectAmount(20)">
          20
        </button>
        <button
          class="quick-select-btn"
          [class.active]="redeemAmount === 50"
          (click)="selectAmount(50)">
          50
        </button>
        <button
          class="quick-select-btn"
          [class.active]="redeemAmount === 100"
          (click)="selectAmount(100)">
          100
        </button>
        <button
          class="quick-select-btn"
          [class.active]="redeemAmount === 200"
          (click)="selectAmount(200)">
          200
        </button>
      </div>

      <button
        [disabled]="!redeemAmount || redeemAmount < 1 || redeemAmount > 1000"
        (click)="proceedToScan()"
        class="redeem-btn">
        {{ 'store.redeem.proceed' | translate }}
      </button>
    </div>
  </div>

  <!-- Code Input Screen -->
  <div *ngIf="showCodeInput && !redeemDone">
    <div class="modal-header">
      <img src="assets/images/x-modal.svg" (click)="close()" alt="">
      <h5>{{ 'store.redeem.title' | translate }}</h5>
    </div>
    <div class="modal-body">
      <div class="label">{{ 'store.redeem.codeLabel' | translate }}</div>
      <div class="input-container">
        <input [(ngModel)]="redeemCode" type="text" class="ltr-input" placeholder="000-000">
        <div *ngIf="invalidCode" style="color: red;font-size: 13px">{{ 'store.redeem.invalidCode' | translate }}</div>
      </div>
      <button [disabled]="!redeemCode" (click)="onRedeem()" class="redeem-btn">{{ 'store.redeem.action' | translate }}</button>
    </div>
  </div>

  <!-- Success Screen -->
  <div class="redeemed-container" *ngIf="redeemDone">
    <img src="assets/images/success_icon.png">
    <h5>{{ 'store.redeem.success' | translate }}</h5>
    <div class="redeemed-note">
      {{ 'store.redeem.successNote' | translate: { currency: currencyCode, amount: redeemAmount } }}
    </div>
    <button class="done-btn" (click)="close()">{{ 'common.done' | translate }}</button>
  </div>
</ng-template>

